import React from "react"
import moment from "moment"

import { Col, Row, Label } from "reactstrap"

const Initialform = ({ dealerData }) => {
  return (
    <React.Fragment>
       <h4 className="card-title mb-2">Dealer Details</h4>
      <Row className="mb-1">
        <Col xs={6} sm={6}  md={4}>
          <Label htmlFor="dealerType" className="col-sm-6 label-styling">
            Dealer Code
          </Label>
          <p>{dealerData?.dealerCode || "-"}</p>
        </Col>
        <Col xs={6} sm={6}  md={4}>
          <Label htmlFor="horizontal-password-Input" className="col-sm-6 label-styling">
            Dealer Name
          </Label>
          <p>{dealerData?.name || "-"}</p>
        </Col>
        <Col xs={6} sm={6}  md={4}>
          <Label htmlFor="horizontal-email-Input" className="col-sm-6 label-styling ">
            Email
          </Label>
          <p>{dealerData?.email || "-"}</p>
        </Col>
      
        <Col xs={6} sm={6}  md={4}>
          <Label htmlFor="horizontal-email-Input" className="col-sm-6 label-styling ">
            Phone
          </Label>
          <p>{dealerData?.phone || "-"}</p>
        </Col>

        <Col xs={6} sm={6}  md={4}>
          <Label htmlFor="horizontal-email-Input" className="col-sm-6 label-styling ">
            PAN
          </Label>
          <p>{dealerData?.pan || "-"}</p>
        </Col>
        <Col xs={6} sm={6}  md={4}>
          <Label htmlFor="horizontal-email-Input" className="col-sm-6 label-styling ">
            GSTN
          </Label>
          <p>{dealerData?.gstIn || "-"}</p>
        </Col>
      
        <Col xs={6} sm={6}  md={4}>
          <Label htmlFor="horizontal-password-Input" className="col-sm-6 label-styling ">
            Contact Person Name
          </Label>
          <p>
            {dealerData?.contacts?.firstName || "-" +
              " " +
              (dealerData?.contacts?.lastName || "")}
          </p>
        </Col>
        <Col xs={6} sm={6}  md={4}>
          <Label htmlFor="horizontal-password-Input" className="col-sm-6 label-styling ">
            Contact Person Mobile
          </Label>
          <p>{dealerData?.contacts?.phone || "-"}</p>
        </Col>
        <Col xs={6} sm={6}  md={4}>
          <Label htmlFor="horizontal-password-Input" className="col-sm-6 label-styling ">
            Region
          </Label>
          <p>{dealerData?.region || "-"}</p>
        </Col>
      
        <Col xs={6} sm={6}  md={4}>
          <Label htmlFor="horizontal-password-Input" className="col-sm-6 label-styling">
            Joining Date <span className="text-danger">*</span>
          </Label>
          <p>{moment(dealerData?.joiningAt || "").format("MMM DD, YYYY") || "-"}</p>
        </Col>
        <Col xs={6} sm={6}  md={4} className="d-flex flex-column">
          <Label htmlFor="horizontal-password-Input" className="col-sm-6 label-styling">
            Sales Office
          </Label>
          <p>
            {dealerData?.salesOffice
              ?.map(office => office.sales_office_name)
              .join(",") || "-"}
          </p>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Initialform
